// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixData from 'wix-data';
$w.onReady(function () {
	 var d = new Date();
 var days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
 let weekday = days[d.getDay()];
    //"Days" < it equal to name of database...
    wixData.query("DailySpecials").eq("day", weekday).find().then((res)=>{
        $w("#DailySpecials").expand();
        $w("#DailySpecials").background.src = res.items[0].image;
    });

 });